<template>
  <PdfDocument class="downloadItem" :name="item.file">
    <div class="downloadItem-preview">
      <MultiImage class="downloadItem-preview-image" :name="imageName" />
    </div>
    <div class="downloadItem-caption">
      <div class="downloadItem-caption-toprow">
        <MultiImage
          class="downloadItem-caption-toprow-icon"
          name="img_download_white_squre"
        />
        <p class="downloadItem-caption-text">
          {{ $i18n.t(item.title) }}
        </p>
      </div>
      <div class="downloadItem-caption-bottomrow">
        <p :v-if="item.subtitle" class="downloadItem-subtext">
          {{ $i18n.t(item.subtitle) }}
        </p>
      </div>
    </div>
  </PdfDocument>
</template>

<script>
import PdfDocument from "@/components/PdfDocument";
import MultiImage from "@/components/MultiImage";

export default {
  name: "DownloadItem",
  components: {
    MultiImage,
    PdfDocument,
  },
  props: {
    item: Object,
  },
  computed: {
    imageName() {
      const locale = this.$i18n.locale === "de" ? "de" : "en";
      const name = this.$props.item.previewImgName + `_${locale}`;
      return name;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/";

.downloadItem {
  &-preview {
    @include flex-v(center, center);
    margin-bottom: 20px;
    padding: 0 10px;

    &-image {
      width: 20vw;

      @include breakpoint(s) {
        width: 28vw;
      }

      @include breakpoint(xs) {
        width: 70%;
      }
    }
  }

  &-caption {
    @include flex-v(center, center);
    height: 80px;
    margin-bottom: 30px;

    &-toprow {
      @include ts-download-caption();
      @include flex-h(center, center);
      flex: 1;

      &-icon {
        height: 45px;
        width: 45px;
        margin-right: 10px;

        @include breakpoint(xs) {
          height: 20px;
          width: 20px;
          margin-right: 5px;
        }
        @include breakpoint(s) {
          height: 20px;
          width: 20px;
        }
      }
    }
    &-bottomrow {
      padding-top: 10px;
      flex: 1;
      font-family: $font_nettoRegular;
      @include text(16px, 16px, 0.14px);
    }
  }
}
</style>
